import React from 'react';
import styled from 'styled-components';
import ScrollSection from './ScrollSection';
import * as S from './Styled';
import LandingSectionHeader from '../../Components/LandingSectionHeader';

function ProductsCat(props) {
  const {categories} = props;
  return (
    <Wrapper>
      <LandingSectionHeader
        title="產品項目"
        subtitle="Product"
        color="#0eb407"
      />
      <ScrollSection list={categories} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 95px 0 95px 45px;
  background-color: #f0f0f0;
`;

export default ProductsCat;
